// Configuração de URLs da API
const API_CONFIG = {
  // URL do servidor de áudio realtime
  REALTIME_SERVER_URL: process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : 'https://www.indec-educ.com.br',

  // Endpoints
  ENDPOINTS: {
    REALTIME_SESSION: '/api/realtime/session',
    REALTIME_TOKEN: '/api/realtime/token',
    HEALTH: '/api/health'
  },

  // Supabase
  SUPABASE: {
    URL: process.env.REACT_APP_SUPABASE_URL,
    ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY
  },

  // OpenAI
  OPENAI: {
    API_KEY: process.env.REACT_APP_OPENAI_API_KEY
  }
};

// Funções auxiliares para construir URLs
export const getRealtimeSessionUrl = () => {
  return `${API_CONFIG.REALTIME_SERVER_URL}${API_CONFIG.ENDPOINTS.REALTIME_SESSION}`;
};

export const getRealtimeTokenUrl = () => {
  return `${API_CONFIG.REALTIME_SERVER_URL}${API_CONFIG.ENDPOINTS.REALTIME_TOKEN}`;
};

export const getHealthCheckUrl = () => {
  return `${API_CONFIG.REALTIME_SERVER_URL}${API_CONFIG.ENDPOINTS.HEALTH}`;
};

export default API_CONFIG;
